<mat-toolbar *ngIf="showFooter" style="padding-top: 0px">
  <mat-toolbar-row class="footer-top-row">
    <div style="margin-top:25px; ">
      <a href="#" onclick="window.scrollTo(1,1) ;return false;"> Return to top</a>
    </div>
  </mat-toolbar-row>
  <mat-toolbar-row class="mainRow ">
    <img class="logo" src="assets/images/wfdss/wfdss_logo_and_text.svg" style="height: 3rem" alt="WFDSS Logo">
    <div class="partners-links">
      <a href="https://www.bia.gov/bia/ots/dfwfm/bwfm" target="_blank">
        <img class="logo" src="assets/images/partners-logos/Bureau_of_Indian_Affairs.svg.png" matTooltipPosition="above"
             matTooltip="DOI Bureau of Indian Affairs" alt="DOI Bureau of Indian Affairs Logo"></a>
      <a href="https://www.blm.gov/programs/public-safety-and-fire" target="_blank">
        <img class="logo" src="assets/images/partners-logos/Bureau_of_Land_Management.svg.png"
             matTooltipPosition="above" matTooltip="DOI Bureau of Land Management" alt="DOI Bureau of Land Management Logo"></a>
      <a href="https://www.fws.gov/fire" target="_blank">
        <img class="logo" src="assets/images/partners-logos/Fish_and_Wildlife_Service.svg.png" matTooltipPosition="above"
             matTooltip="US Fish and Wildlife Service" alt="US Fish and Wildlife Service Logo"></a>
      <a href="https://www.nps.gov/subjects/fire/index.htm" target="_blank">
        <img class="logo" src="assets/images/partners-logos/National_Park_Service.svg.png" matTooltipPosition="above"
             matTooltip="US National Park Service" alt="US National Park Service Logo"></a>
      <a href="https://www.fs.usda.gov/managing-land/fire" target="_blank">
        <img class="logo" src="assets/images/partners-logos/Forest_Service.svg.png" matTooltipPosition="above"
             matTooltip="US Forest Service" alt="US Forest Service Logo"></a>
    </div>
  </mat-toolbar-row>
  <mat-toolbar-row class="footer-bottom-row">
    <div class="route-container" style="padding-top: 0px">
      <a href="https://famit.nwcg.gov/" target="_blank">Partners</a>
      <span class="vertical-divider">|</span>
      <a href="https://www.usda.gov/accessibility-statement" target="_blank">Accessibility</a>
      <span class="vertical-divider">|</span>
      <a href=" https://www.usda.gov/privacy-policy" target="_blank">Privacy Policy</a>
      <span class="vertical-divider">|</span>
      <a href=" https://www.dm.usda.gov/foia/" target="_blank">FOIA</a>
      <span class="vertical-divider">|</span>
      <a href="https://www.usda.gov/non-discrimination-statement" target="_blank">Non-Discrimination Statement</a>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
